/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SecurityHelper, Button } from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';
import { gnoment } from 'shared-ui/gnoment';
import { authModalActions } from 'shared-ui/auth/redux';
import { PERMIT, SEASON } from '../propTypes';
import { ALL_DIVISION_TO_TYPE_MAPPING } from '../utils/utils';

class CapeLookoutSidebar extends React.Component {
    static propTypes = {
        permit: PERMIT.isRequired,
        seasons: PropTypes.arrayOf(SEASON),
        pActions: PropTypes.object.isRequired,
        openLoginModal: PropTypes.func.isRequired,
        account: PropTypes.object,
        router: COMPAT_ROUTER_PROP_TYPES,
    };

    constructor(props) {
        super(props);
        this.state = {
            waitingForUserAccount: false,
        };
    }

    componentDidMount() {
        this.props.pActions.purgePendingReservations();
    }

    componentDidUpdate(prevProps) {
        if (
            SecurityHelper.isLoggedIn() &&
            this.state.waitingForUserAccount &&
            this.props.account &&
            prevProps.account !== this.props.account
        ) {
            this.setState({ waitingForUserAccount: false });
            this.continueClick();
        }
    }

    continueClick = () => {
        const loggedin = SecurityHelper.isLoggedIn();
        if (!loggedin) {
            this.setState({ waitingForUserAccount: true });
            this.props.openLoginModal();
            return;
        }
        const selectedPermitType = '333240201';
        const item = {
            division_id: selectedPermitType,
            permit_type: ALL_DIVISION_TO_TYPE_MAPPING[selectedPermitType],
            permit_id: this.props.permit.id,
            start_date: gnoment(`${gnoment().year()}-03-12`),
            end_date: gnoment(`${gnoment().year()}-12-31`),
        };

        this.props.pActions.createPendingReservations([item]);

        this.props.router.navigate(
            `/vehiclepermits/${this.props.permit.id}/order/detail`
        );
    };

    render() {
        const { seasons } = this.props;
        return (
            <div>
                <Button
                    onClick={this.continueClick}
                    className="rec-button-primary-large bottom-3"
                    shouldFitContainer
                    disabled={!seasons?.length}
                >
                    Get Permits
                </Button>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openLoginModal: bindActionCreators(authModalActions.openLoginModal, dispatch),
    };
}

export default withCompatRouter(connect(null, mapDispatchToProps)(CapeLookoutSidebar));
